module.exports = __webpack_public_path__ + "static/media/48421404_2308810415860803_7379775509938307072_o-thumb.e8078133.jpg";